const SDK_VERSION = "11.10.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
